import { Box, StateNode, pointInPolygon } from "@tldraw/editor";
class Erasing extends StateNode {
  static id = "erasing";
  static trackPerformance = true;
  info = {};
  scribbleId = "id";
  markId = "";
  excludedShapeIds = /* @__PURE__ */ new Set();
  _erasingShapeIds = [];
  onEnter(info) {
    this.markId = this.editor.markHistoryStoppingPoint("erase scribble begin");
    this.info = info;
    const originPagePoint = this.editor.inputs.getOriginPagePoint();
    this.excludedShapeIds = new Set(
      this.editor.getCurrentPageShapes().filter((shape) => {
        if (this.editor.isShapeOrAncestorLocked(shape)) return true;
        if (this.editor.isShapeOfType(shape, "group") || this.editor.isShapeFrameLike(shape)) {
          const pointInShapeShape = this.editor.getPointInShapeSpace(shape, originPagePoint);
          const geometry = this.editor.getShapeGeometry(shape);
          return geometry.bounds.containsPoint(pointInShapeShape);
        }
        return false;
      }).map((shape) => shape.id)
    );
    this._erasingShapeIds = this.editor.getShapesAtPoint(originPagePoint).filter((s) => !this.excludedShapeIds.has(s.id)).map((s) => s.id);
    this.editor.setErasingShapes([
      .../* @__PURE__ */ new Set([...this.editor.getErasingShapeIds(), ...this._erasingShapeIds])
    ]);
    const scribble = this.editor.scribbles.addScribble({
      color: "muted-1",
      size: 12
    });
    this.scribbleId = scribble.id;
    this.update();
  }
  pushPointToScribble() {
    const { x, y } = this.editor.inputs.getCurrentPagePoint();
    this.editor.scribbles.addPoint(this.scribbleId, x, y);
  }
  onExit() {
    this.editor.setErasingShapes([]);
    this.editor.scribbles.stop(this.scribbleId);
  }
  onPointerMove() {
    this.update();
  }
  onPointerUp(info) {
    this.complete(info);
  }
  onCancel() {
    this.cancel();
  }
  onComplete() {
    this.complete();
  }
  update() {
    const { editor, excludedShapeIds } = this;
    const erasingShapeIds = editor.getErasingShapeIds();
    const currentPagePoint = editor.inputs.getCurrentPagePoint();
    const previousPagePoint = editor.inputs.getPreviousPagePoint();
    this.pushPointToScribble();
    const erasing = new Set(erasingShapeIds);
    const minDist = this.editor.getHitTestMargin();
    const lineBounds = Box.FromPoints([previousPagePoint, currentPagePoint]).expandBy(minDist);
    const candidateIds = editor.getShapeIdsInsideBounds(lineBounds);
    if (candidateIds.size === 0) {
      editor.setErasingShapes(Array.from(erasing));
      return;
    }
    const allShapes = editor.getCurrentPageRenderingShapesSorted();
    const currentPageShapes = allShapes.filter((shape) => candidateIds.has(shape.id));
    for (const shape of currentPageShapes) {
      if (editor.isShapeOfType(shape, "group")) continue;
      const pageMask = editor.getShapeMask(shape.id);
      if (pageMask && !pointInPolygon(currentPagePoint, pageMask)) {
        continue;
      }
      const geometry = editor.getShapeGeometry(shape);
      const pageTransform = editor.getShapePageTransform(shape);
      if (!geometry || !pageTransform) continue;
      const pt = pageTransform.clone().invert();
      const A = pt.applyToPoint(previousPagePoint);
      const B = pt.applyToPoint(currentPagePoint);
      const { bounds } = geometry;
      if (bounds.minX - minDist > Math.max(A.x, B.x) || bounds.minY - minDist > Math.max(A.y, B.y) || bounds.maxX + minDist < Math.min(A.x, B.x) || bounds.maxY + minDist < Math.min(A.y, B.y)) {
        continue;
      }
      if (geometry.hitTestLineSegment(A, B, minDist)) {
        const outermost = editor.getOutermostSelectableShape(shape);
        if (excludedShapeIds.has(outermost.id)) {
          erasing.add(
            editor.getOutermostSelectableShape(shape, (s) => !excludedShapeIds.has(s.id)).id
          );
        } else {
          erasing.add(outermost.id);
        }
      }
      this._erasingShapeIds = [...erasing];
    }
    this.editor.setErasingShapes(this._erasingShapeIds.filter((id) => !excludedShapeIds.has(id)));
  }
  complete(info) {
    const { editor } = this;
    editor.deleteShapes(editor.getCurrentPageState().erasingShapeIds);
    this.parent.transition("idle", info);
    this._erasingShapeIds = [];
  }
  cancel() {
    const { editor } = this;
    editor.bailToMark(this.markId);
    this.parent.transition("idle", this.info);
  }
}
export {
  Erasing
};
//# sourceMappingURL=Erasing.mjs.map
